import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { RecuperaConfiguracionAplicacionApiService } from 'src/app/pages/configuracion/configuracion-rlt/services/recupera-configuracion-aplicacion-api.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ModuloEnvioSimpleGuard implements CanActivate {

  constructor(
    private recuperaConfiguracionAplicacionService: RecuperaConfiguracionAplicacionApiService,
    private router: Router
  ) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.recuperaConfiguracionAplicacionService.getModulosActivos().pipe(
      map(result => {
        if (result.ModuloEnvioSimpleActivo) {
          return true;
        }
        this.router.navigate(['/panel/main']);
        return false;
      }),
      catchError(() => {
        this.router.navigate(['/panel/main']);
        return of(false);
      })
    );
  }
}
